const capsPattern = {
  eloopf: "x{DNQ}x(2){GP}{ENPQS}x(2){DPQR}[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED][FLYMVIW]x(2){NPS}{DENQ}x(3)",
  eloop: "x{DNQ}x(2){GP}{ENPQS}x(2){DPQR}[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED]",
  loopf: "[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED][FLYMVIW]x(2){NPS}{DENQ}x(3)",
  loop: "[DNS]x[DNS]{FLIVWY}[DNESTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[ED]",
  PC: "[LMVITNF][FY]x(2)[YHIVF][SAITV]x(5,9)[LIVM]x(3)[EDS][LFM][KRQLE]x(20,28)[LQKF][DNG]x[DNSC]x[DNK]x(4)[FY]x[EKS]",
  Pseudo:"[LMVITNF][FY]x(2)[YHIVF][SAITV]x(5,9)[LIVM]x(3)[EDS][LFM][KRQLE]",
  Excalibur: "DxDxDGx(2)CE",
  EF_hand_like:"Dx[DNS]{ILVFYW}[DEN]G{GP}x(5,6)[DE]",
  SP00018: "Dx[DNS]{ILVFYW}[DENSTG][DNQGHRK]{GP}[LIVMC][DENQSTAGC]x(2)[DE][LIVMFYW]",
  PS00303:"[LIVMFYW](2)x(2)[LK]Dx(3)[DN]x(3)[DNSG][FY]x[ES][FYVC]x(2)[LIVMFS][LIVMF]"
}

export default JSON.stringify(capsPattern, null, "  ");
